import React, { useRef } from 'react';
import { IconButton, Badge, ClickAwayListener, Tooltip } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useNotifications } from '../context/NotificationContext';
import NotificationDropdown from './NotificationDropdown';

/**
 * NotificationBell Component
 * Bell icon with badge that shows unread count and opens dropdown menu
 */
const NotificationBell = () => {
    const { unreadCount, isDropdownOpen, toggleDropdown, closeDropdown } = useNotifications();

    const bellRef = useRef(null);

    const handleClickAway = () => {
        if (isDropdownOpen) {
            closeDropdown();
        }
    };

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <div style={{ position: 'relative', display: 'inline-block' }}>
                <Tooltip title="Notifications">
                    <IconButton
                        ref={bellRef}
                        onClick={toggleDropdown}
                        sx={{
                            color: 'primary.main',
                            '&:hover': {
                                backgroundColor: 'rgba(11, 21, 55, 0.04)',
                            },
                        }}
                    >
                        <Badge
                            badgeContent={unreadCount}
                            color="error"
                            max={99}
                            sx={{
                                '& .MuiBadge-badge': {
                                    fontSize: '0.75rem',
                                    height: 18,
                                    minWidth: 18,
                                    fontWeight: 600,
                                },
                            }}
                        >
                            <NotificationsIcon sx={{ fontSize: 28 }} />
                        </Badge>
                    </IconButton>
                </Tooltip>

                <NotificationDropdown
                    open={isDropdownOpen}
                    anchorEl={bellRef.current}
                    onClose={closeDropdown}
                />
            </div>
        </ClickAwayListener>
    );
};

export default NotificationBell;
